import { useAcsFetch } from '../hooks/use-acs-fetch'
import { UpdateOptions } from '../types'

export const useAccountDetailsApi = (): {
  updateAccountDetails: (
    accountId: string,
    options: UpdateOptions,
  ) => Promise<{ data: null }>
  updateCdAccountDetails: (
    accountId: string,
    options: UpdateOptions,
  ) => Promise<{ data: null }>
} => {
  const acsFetch = useAcsFetch({
    withCif: true,
    withGuid: true,
    defaultHeaders: {
      ApplicationVersion: '2.9',
      ApplicationID: 'ALLYUSBOLB',
      ApplicationName: 'AOB',
    },
  })

  const updateAccountDetails = async (
    accountId: string,
    options: UpdateOptions,
  ): Promise<{ data: null }> => {
    const result = await acsFetch<{ data: null }>(
      `/v1/bank-accounts/${accountId}/update`,
      {
        method: 'PATCH',
        body: JSON.stringify(options),
      },
    )
    return result.data
  }

  const updateCdAccountDetails = async (
    accountId: string,
    options: UpdateOptions,
  ): Promise<{ data: null }> => {
    const result = await acsFetch<{ data: null }>(
      `/v1/bank-accounts/${accountId}/updateCD`,
      {
        method: 'PATCH',
        body: JSON.stringify(options),
      },
    )
    return result.data
  }
  return {
    updateAccountDetails,
    updateCdAccountDetails,
  }
}
